module.exports = __webpack_public_path__ + "img/uploadTestCase.6b239594.svg";